import { render } from "./tab-list.vue?vue&type=template&id=6ea7b1f3"
import script from "./tab-list.vue?vue&type=script&lang=js"
export * from "./tab-list.vue?vue&type=script&lang=js"

import "./tab-list.vue?vue&type=style&index=0&id=6ea7b1f3&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__